import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagService {
  constructor() {}

  public checkFeature(feature: string): boolean {
    const flags = [{ name: 'weight-control', active: true }];
    return flags.some((x) => {
      return x.name === feature && x.active === true;
    });
  }
}
